/*
 * @Auther: 罗耀祖
 * @Date: 2021-07-06 17:59:10
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-04-20 17:21:39
 * @name: 短信对象
 * @Description: 短信对象
 * @FilePath: \preSaleNafterSaleBackstage\src\object\sms\sms.class.js
 * @Author: DESKTOP-1QU67QM
 */
const sms = class sms {
    constructor() {
        this.countdown = 60; //短信有效期
    }
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 发送验证码
     * @return {Promise} resolve: 成功回调, reject: 失败回调
     */
    async sendVerificationCode() {
        return Promise.resolve();
    }
}

export default sms;
